<template>
  <div style="text-align: center;margin-bottom: 600px">
    智慧电力
  </div>
</template>

<script>
export default {
  name: "power",
  components: {
  },
  data() {
    return {

    };
  },
  created() {},

  mounted() {

  }
};
</script>

<style lang="scss" scoped>

</style>